var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Artboard1","x":"0","y":"0","width":"24.219","height":"14.999","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M2.953,0.106l9.17,9.17l9.17,-9.17l2.83,2.83l-12,12l-12,-12l2.83,-2.83Z","style":{"fillRule":"nonzero"},"key":1})]);
}

ArrowIcon.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 25 15","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
